<template>
  <div>
    <right-panel class="float-right" id="sidebar-new-datasource" width="600px" :icon="'mdi mdi-plus'" :text="$t('datasource.new')" @hidden="rightPanelClosed">
      <div class="pl-5 pr-5">
        <Form />
      </div>
    </right-panel>

    <h2
      v-if="parentEntity"
      v-html="$t('datasource.owned-list', { department: $options.filters.translate(parentEntity.department.name), name: $options.filters.translate(parentEntity.name) })"
    ></h2>

    <nav class="breadcrumb" v-if="parentEntity">
      <a class="breadcrumb-item" href="/organization">
        {{ $t("organization.text") }}
      </a>

      <a class="breadcrumb-item" :href="`/department-process/${parentEntity.department._id}`">
        {{ parentEntity.department.name | translate }}
      </a>

      <a class="breadcrumb-item" href="javascript:;">
        {{ parentEntity.name | translate }}
      </a>
      <a class="breadcrumb-item text-muted" href="javascript:;">
        {{ $t("datasource.plural") }}
      </a>
    </nav>

    <table class="table project-list-table table-centered table-borderless compact ">
      <tr>
        <th scope="col" style="width:300px">
          <sortable-table-head field="name" :text="$t('datasource.name')" tag="span" :request="request" />
        </th>

        <th scope="col" style="width: 15%">
          <a href="javascript:;" @click="toggleFilter">
            <span v-if="filterEnabled" class="text-warning">
              <i class="bx bxs-filter-alt"></i>
              {{ $t("common.filters-hide") }}
            </span>
            <span v-else class="text-muted">
              <i class="bx bxs-filter-alt"></i>
              {{ $t("common.filters-show") }}
            </span>
          </a>
        </th>
      </tr>

      <tr v-if="filterEnabled">
        <th><input class="form-control" v-model="nameFilter" :placeholder="$t('common.search')" /></th>
        <th></th>
      </tr>
    </table>

    <div v-if="pagination" class="row">
      <div class="col-2 hider font-small" v-for="item in pagination.docs" :key="item._id">
        <div class="card text-center p-2" v-bind:class="{ 'bg-success': item.completed }">
          <div @click="routerPush(item)">
            <div class="mt-2 text-truncate hand">
              <h6 v-b-tooltip.hover :title="$options.filters.translate(item.name)">
                {{ item.datasource.name | translate }}
              </h6>
              <span v-if="item.process" class="mb-0 text-muted">
                {{ item.process.name | translate }}
              </span>
              <span v-else class="text-light-gray" v-b-tooltip.hover :title="$t('datasource.no-process')">
                {{ $t("datasource.no-process") }}
              </span>
            </div>
          </div>
          <div v-if="hasUpdatePermission || hasRemovePermission" class="hidden">
            <div class="d-flex mt-3 team-social-links">
              <div v-if="hasUpdatePermission" class="flex-fill">
                <a @click="edit(item)" v-b-toggle="'sidebar-edit-organization-process-datasource'" v-b-tooltip.hover :title="$t('common.edit')">
                  <i class="bx bx-pencil text-primary"></i>
                </a>
              </div>

              <div v-if="hasRemovePermission" class="flex-fill">
                <a href="javascript:;void(0);" @click="deleteById(item)" v-b-tooltip.hover :title="$t('common.delete')">
                  <i class="bx bx-trash-alt text-danger"></i>
                </a>
              </div>
              <div class="flex-fill mt-1" v-b-tooltip.hover :title="$t('common.completed')">
                <b-form-checkbox switch size="sm" :checked="item.completed" @change="markAsComplete(item)" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->

    <content-loading v-if="isLoading" />

    <empty v-if="!isLoading && (!pagination || pagination.docs.length == 0)">
      <h5 class="text-center">
        {{ $t("datasource.no-data") }}
      </h5>
    </empty>

    <!-- Begin: Pagination -->

    <div v-if="pagination" class="row">
      <div class="col">
        <ul class="pagination pagination-rounded mb-0">
          <b-pagination v-model="request.options.page" :total-rows="pagination.totalDocs" :per-page="pagination.limit" limit="10" size="sm"></b-pagination>
        </ul>
      </div>
    </div>
    <!-- End: Pagination -->
  </div>
</template>

<script>
import Form from "./organization-process-datasource-form";

export default {
  components: { Form },
  data() {
    return {
      request: {
        options: { page: 1, limit: 15, sort: { name: "asc" } },
        query: {},
      },
      nameFilter: undefined,
      filterEnabled: false,
    };
  },
  computed: {
    selectedEntity() {
      return this.$store.getters["organizationProcessDatasource/selectedEntity"];
    },
    parentEntity() {
      return this.$store.getters["organizationDepartmentProcess/selectedEntity"];
    },
    pagination() {
      return this.$store.getters["organizationProcessDatasource/pagination"];
    },
    isLoading() {
      return this.$store.getters["organizationProcessDatasource/isLoading"];
    },
    hasUpdatePermission() {
      return true;
    },
    hasRemovePermission() {
      return true;
    },
  },
  watch: {
    "$route.params.department_process": {
      immediate: true,
      handler() {
        this.fetchParent();
      },
    },
    request: {
      deep: true,
      handler() {
        this.debounce(() => this.paginate());
      },
    },
    nameFilter(n, o) {
      if (n) {
        this.request.query = { ...this.request.query, name: { value: n } };
      } else {
        this.request.query["name"] = null;
        delete this.request.query["name"];
      }
    },
  },
  mounted() {},
  methods: {
    async fetchParent() {
      this.$store.commit("organizationDepartmentProcess/selectedEntity", undefined);
      this.$store.commit("organizationProcessDatasource/pagination", undefined);

      const parentId = this.$route.params.department_process;
      if (parentId) {
        await this.$store.dispatch("organizationDepartmentProcess/findById", parentId);
      }
      this.paginate();
    },
    async paginate() {
      const request = { ...this.request };
      if (this.parentEntity) {
        request.query = {
          ...request.query,
          process: { value: { _id: this.parentEntity._id }, isObject: true },
        };
      }

      await this.$store.dispatch("organizationProcessDatasource/paginate", request);
    },

    async deleteById(item) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        await this.$store.dispatch("organizationProcessDatasource/delete", item._id);
        this.$toast.success("'" + this.$options.filters.translate(item.name) + "' Silindi");
        this.paginate();
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error, { customMessage: "'" + this.$options.filters.translate(item.name) + "' Silinemedi" });
      }
    },

    async markAsComplete(item) {
      try {
        await this.$store.dispatch("organizationProcessDatasource/markAsComplete", item._id);
        this.paginate();
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },
    edit(item) {
      this.$store.commit("organizationProcessDatasource/editedEntity", item);
      this.$root.$emit("bv::toggle::collapse", "sidebar-new-datasource");
    },

    toggleFilter() {
      this.filterEnabled = !this.filterEnabled;

      if (!this.filterEnabled) {
        this.request = {
          options: { page: 1, limit: 15, sort: { name: "asc" } },
          query: {},
        };
        this.nameFilter = undefined;
        this.categoryFilter = undefined;
      }
    },

    routerPush(item) {
      this.$router.push("/datasource-data/" + item._id);
    },
    rightPanelClosed() {
      this.paginate();
      this.$store.commit("organizationProcessDatasource/editedEntity");
      this.$store.commit("organizationProcessDatasource/copingEntity");
      // this.$store.dispatch("organizationProcessDatasource/resetForm");
    },
  },
};
</script>
